import { render } from "./Span.vue?vue&type=template&id=9bf62074&scoped=true"
import script from "./Span.vue?vue&type=script&lang=js"
export * from "./Span.vue?vue&type=script&lang=js"

import "./Span.vue?vue&type=style&index=0&id=9bf62074&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bf62074"]])

export default __exports__